import { useMemo } from 'react';
import { useGetUser } from '../api';

export const useIsLoggedIn = () => {
	const { data, isLoading } = useGetUser();
	return useMemo(() => [!!data, isLoading], [data, isLoading]);
};
